import React from "react";
import { motion } from "framer-motion";
import { FONTS } from "./landingTheme";

/* ─────────────────────── FOOTER ─────────────────────── */
const Footer = ({ colors, onOpenContact }) => {
    const linkStyle = { textDecoration: "none", fontFamily: FONTS.body, fontSize: 12, color: colors.textMuted, cursor: "pointer", transition: "color 0.2s" };
    const separatorStyle = { color: "rgba(120,120,120,0.3)", fontSize: 12, margin: "0 8px" };

    return (
        <motion.footer initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }} transition={{ duration: 0.7 }} style={{ padding: "40px 24px", width: "100%", borderTop: "1px solid rgba(120,120,120,0.1)", boxSizing: "border-box" }}>
            <div style={{ maxWidth: 1300, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16 }}>
                {/* Linha 1 */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
                    <div style={{ fontFamily: FONTS.body, fontSize: 12, color: colors.textMuted }}>
                        Copyright © {new Date().getFullYear()} Entertainment Maintenance. Todos os direitos reservados. CNPJ: 00.000.000/0001-00
                    </div>
                    <div style={{ fontFamily: FONTS.body, fontSize: 12, color: colors.textMuted }}>
                        Brasil
                    </div>
                </div>
                {/* Linha 2 */}
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap" }}>
                    <a href="/privacidade" style={linkStyle} onMouseEnter={(e) => (e.target.style.color = colors.textDark)} onMouseLeave={(e) => (e.target.style.color = colors.textMuted)}>Política de Privacidade</a>
                    <span style={separatorStyle}>|</span>
                    <a href="/termos" style={linkStyle} onMouseEnter={(e) => (e.target.style.color = colors.textDark)} onMouseLeave={(e) => (e.target.style.color = colors.textMuted)}>Termos de Uso</a>
                    <span style={separatorStyle}>|</span>
                    <span role="button" tabIndex={0} onClick={onOpenContact} onKeyDown={(e) => e.key === "Enter" && onOpenContact()} style={linkStyle} onMouseEnter={(e) => (e.target.style.color = colors.textDark)} onMouseLeave={(e) => (e.target.style.color = colors.textMuted)}>Contato</span>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;

